import { STATIC_FILTER_ENTITY_TYPES } from '@shared/features/views/components/entities-filters/config';
import {
  FILTER_KIND,
  type TDateRangeFilterConfig,
} from '../types/filter-config';

export const createDateRangeFilterConfig = (
  config: Omit<TDateRangeFilterConfig, 'kind' | 'entityType'>
): TDateRangeFilterConfig => ({
  kind: FILTER_KIND.dateRange,
  entityType: STATIC_FILTER_ENTITY_TYPES.date,
  ...config,
});
